<template>
  <div>
    <el-dialog class="newDialog carte previewFile" title="個人名片" :visible.sync="visible">
      <SaleBusinessCardPreview ref="saleBusinessCardPreview"></SaleBusinessCardPreview>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">送 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { SaleBusinessCardHandler } from "@/handler/SaleBusinessCardHandler.js";
import SaleBusinessCardPreview from "../../components/Main/SaleBusinessCardPreview.vue";
import store_saleBusinessCard from "@/vuex/store_saleBusinessCard.js";

export default {
  name: "SaleBusinessCard",
  data() {
    return {
      visible: false
    };
  },
  components: {
    SaleBusinessCardPreview
  },
  methods: {
    inidata: function() {
      this.visible = true;
      this.$refs.saleBusinessCardPreview.initBusinessCardInfo();
    },
    submitForm() {
      if(this.saleBusinessCard.selfIntro == "" || this.saleBusinessCard.selfIntro == null ){
        alert('名片尚未設定！');
        return;
      }
      SaleBusinessCardHandler.SendShareStaffBusinessCardFlexMessage();
      this.visible = false;
    }
  },
  computed: {
    saleBusinessCard() {
      return store_saleBusinessCard.state;
    }
  },
};
</script> 
<style>
</style>


// WEBPACK FOOTER //
// src/components/Main/ChatToolBar_SaleBusinessCard.vue